import React, { useState } from "react";
import Content from "../../../Components/Dashboard/Content/Content";
import { Eye } from "lucide-react";
import { useDispatch } from "react-redux";
import { Broker_drtails } from "../../../ReduxStore/Slice/Superadmin/SuperAdminSlice";

function BrokerDetails() {
    const dispatch = useDispatch();

    const [GetAllBrokerName] = useState([
        { id: "1", name: "Coin Dcx" },
        { id: "2", name: "Delta Exchange" },
        { id: "3", name: "Binance" },
        { id: "4", name: "Zabpay" },
        { id: "5", name: "Coinswitch" },
        { id: "6", name: "Pi42" }
    ]);

    const [loading, setLoading] = useState(false);
    const [PanelData, setPanelData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedBroker, setSelectedBroker] = useState(null);

    // Fetch panel summary for broker
    const handleViewUsers = async (broker) => {

        setLoading(true);
        setSelectedBroker(broker);

        try {
            const req = { broker: broker.id };
            const response = await dispatch(Broker_drtails(req)).unwrap();

            if (response?.status) {
                setPanelData(response.data);
                setShowModal(true);
            }
        } catch (err) {
            console.error("API Error:", err);
        }

        setLoading(false);
    };

    return (
        <Content Page_title="Broker Details" Filter_tab={false} button_status={false}>
            <div className="container py-4">

                <div className="row g-4 justify-content-center">
                    {GetAllBrokerName.map((broker) => (
                        <div key={broker.id} className="col-12 col-md-6 col-lg-4">

                            <div
                                className="card border-0 h-100 text-center p-4"
                                style={{
                                    borderRadius: "16px",
                                    background: "linear-gradient(135deg, #ffffff, #eef2f7)",
                                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                                }}
                            >
                                <h4 className="fw-bold mb-3">{broker.name}</h4>

                                <button
                                    className="btn btn-primary btn-sm mt-3 px-4 d-flex mx-auto align-items-center gap-2"
                                    onClick={() => handleViewUsers(broker)}
                                    disabled={loading}
                                >
                                    <Eye size={18} />
                                    {loading && selectedBroker?.id === broker.id ? " Loading..." : " View Panels"}
                                </button>
                            </div>

                        </div>
                    ))}
                </div>


                {/* ---- PANEL SUMMARY MODAL ---- */}
                {showModal && (
                    <div className="modal d-block" style={{ background: "rgba(0,0,0,0.4)" }}>
                        <div className="modal-dialog modal-xl">
                            <div className="modal-content" style={{ borderRadius: "12px" }}>

                                <div className="modal-header">
                                    <h5 className="modal-title fw-semibold">
                                        Broker Summary: {selectedBroker?.name}
                                    </h5>
                                    <button className="btn-close" onClick={() => setShowModal(false)}></button>
                                </div>

                                <div className="modal-body">

                                    {PanelData?.length === 0 ? (
                                        <p className="text-center text-muted">No panel found for this broker.</p>
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="table table-hover align-middle text-center">
                                                <thead className="table-light">

                                                    <tr>
                                                        <th>Panel Name</th>
                                                        {/* <th>Domain</th> */}
                                                        <th>Total Users</th>
                                                        <th>Active Users</th>
                                                        <th>Trading Status</th>   {/* NEW COLUMN */}
                                                        {/* <th>Trading Status</th> */}
                                                    </tr>


                                                </thead>

                                                <tbody>
                                                    {PanelData.map((panel, i) => (
                                                        <tr key={i}>
                                                            <td>
                                                                <a
                                                                    href={panel.domain}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    style={{ color: "#1976d2", cursor: "pointer", textDecoration: "underline" }}
                                                                >
                                                                    {panel.panel_name}
                                                                </a>
                                                            </td>

                                                            {/* <td>{panel.domain}</td> */}
                                                            <td>{panel.total_clients}</td>
                                                            <td>{panel.active_clients}</td>
                                                            <td>{panel.trading_on_users}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>


                                            </table>
                                        </div>
                                    )}

                                </div>

                            </div>
                        </div>
                    </div>
                )}

            </div>
        </Content>
    );
}

export default BrokerDetails;
